export const BREAKPOINT_SMALL = 0;
export const BREAKPOINT_MEDIUM = 600;
export const BREAKPOINT_LARGE = 1024;
export const BREAKPOINT_XLARGE = 1440;
export const THUMBNAILS_PER_ROW = {
    MOBILE_SHOW_MORE: 4,
    MOBILE: 5,
    DESKTOP: 6,
};
export const THUMBNAILS_PER_ROW_LIGHT_BOX = {
    MOBILE: 5,
    TABLET: 5,
    DESKTOP: 8,
    LDESKTOP: 10,
};
export const GALLERY_ITEM_HEIGHT = {
    MOBILE: '18.75rem',
    DESKTOP: '25rem',
} as const;
